import { auth, app } from './Api';

const authentication = async (data) => auth.post('login', data);
const information = async () => app.post('me');
const register = async (data) => app.post('register', data);
const updatePassword = async (data) => app.put('userPassword/edit', data);
const rememberPassword = async (data) => auth.post(`forgot/password`, data);
const updatePasswordRemember = async (data) => auth.post(`reset/password`, data);

export { authentication, information, register, updatePassword, rememberPassword, updatePasswordRemember };
